import { useAuth0 } from '@auth0/auth0-react';
import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { Duration } from '../constants';

export default function useTokenQuery() {
  const { getAccessTokenSilently } = useAuth0();
  const toast = useToast();

  const query = useQuery({
    queryKey: getKey(),
    queryFn: () => {
      let token = getAccessTokenSilently();
      return token as Promise<string>;
    },
    staleTime: Duration.Minute * 10,
    refetchInterval: Duration.Minute * 10,
    refetchOnWindowFocus: true,
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey() {
  return ['Token'] as const satisfies QueryKey;
}
useTokenQuery.getKey = getKey;
